import { Component, OnInit } from '@angular/core';
import { MainPageComponent } from '../../../shared/_components/main-page/main-page.component';
import { TransactionsListComponent } from '../transactions-list/transactions-list.component';
import { Store } from '@ngrx/store';
import { MenuActionsService } from '../../../navigation/_services/menu-actions.service';
import { NavigationActions } from '../../../navigation/_store/navigation.actions';
import { NavigationActionTypes } from '../../../navigation/_models/navigation.models';

@Component({
  selector: 'app-transactions-home',
  standalone: true,
  imports: [MainPageComponent, TransactionsListComponent],
  templateUrl: './transactions-home.component.html',
  styleUrl: './transactions-home.component.scss'
})
export class TransactionsHomeComponent implements OnInit {
  constructor(private store: Store, private menuService: MenuActionsService) {
  }

  ngOnInit(): void {
    this.store.dispatch(NavigationActions.updateMenuNavigation({ menu: this.menuService.populateMenu([NavigationActionTypes.AddTransaction]) }));
  }
}
